import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export const AiMarkdown = ({ text }) => (
    <div className="ai-md text-sm text-ink/85 leading-relaxed break-words">
        <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
);

export default AiMarkdown;
